import { Link } from 'react-router'
import { ReactSVG } from 'react-svg'

import { CATEGORY_DEFAULT_ICON_PATH } from '@shared/contants/product'

import styles from './styles.module.scss'

interface CategoryParentProps {
  name: string;
  iconUrl?: string | null | undefined;
  to?: string;
}

export default function CategoryParent (props: CategoryParentProps) {
  const { name, to, iconUrl } = props

  const content = (
    <span className={styles['parent-link']}>
      <div className={styles.img}>
        {iconUrl ? (
          <img
            src={iconUrl ?? undefined}
            alt=""
            loading="lazy"
            fetchPriority="low"
          />
        ) : (
          <ReactSVG
            src={CATEGORY_DEFAULT_ICON_PATH}
            width={16}
            height={16}
            wrapper="span"
          />
        )}
      </div>
      {name}
    </span>
  )

  return to ? (
    <Link className={styles['parent-link']} to={to}>
      {content}
    </Link>
  ) : (
    content
  )
}
